import React, { Component } from 'react';
import Tab from '../../common/tab';
import { getQueryParams } from '../../helpers/Common';
import ExportData from './ExportData';
import FADividendAnalysisTable from './FADividendAnalysisTable';
import Footer from './../../common/table/Footer';
import { withComponentId } from './../../common/ComponentIdContext';
import { connect } from 'react-redux';
import {
  fetchAnalysis,
  fetchCompanyScore,
  fetchLastPrice,
  REDUCER_NAME,
} from './reducer';
import { compose } from 'redux';

class FADividendTab extends Component {
  componentDidMount() {
    const {
      componentId,
      fetchAnalysis,
      fetchCompanyScore,
      fetchLastPrice,
      condition: { currentSearch },
    } = this.props;

    const { code } = currentSearch;

    if (!getQueryParams('code')) {
      fetchAnalysis(code, componentId);
      fetchLastPrice(code, componentId);
      fetchCompanyScore(code, componentId);
    }
  }

  render() {
    const {
      condition: { currentSearch },
    } = this.props;
    return (
      <div
        style={{ minHeight: 230 }}
        className="top-nav pt-10 d-flex flex-column"
      >
        <Tab
          currentTab={1}
          listTab="cashDividend.listTab"
          isLineLinkLeft={true}
        />
        <div className="tab-content d-flex flex-fill flex-column h-auto">
          <ExportData
            code={currentSearch.code}
            displayCode={currentSearch.displayCode}
          />
          <FADividendAnalysisTable />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    condition: state[REDUCER_NAME].listMultiComponent[componentId].condition,
  };
};

const mapSDispatchToProps = {
  fetchAnalysis,
  fetchCompanyScore,
  fetchLastPrice,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapSDispatchToProps,
  ),
)(FADividendTab);
